import { atom } from 'jotai';
import { ScopeProvider } from 'jotai-scope';

import { swingFoundationParameterIdsAtom } from '@store';

/**
 * State
 */

export const selectedParameterIdsAtom = atom<string[] | null>(null);

export const displaySelectedParameterIds = atom((get) => {
    const selection = get(selectedParameterIdsAtom);
    const current = get(swingFoundationParameterIdsAtom);
    return selection === null ? current : selection;
});

/**
 * Actions
 */

export const selectParameterIdAtom = atom<null, [parameterId: string], void>(null, (get, set, parameterId) => {
    const selection = get(displaySelectedParameterIds);
    return set(
        selectedParameterIdsAtom,
        selection.includes(parameterId) ? selection.filter((id) => id !== parameterId) : [...selection, parameterId],
    );
});

export const selectManyParameterIdsAtom = atom<null, [parameterId: string[]], void>(null, (get, set, parameterIds) => {
    const selection = get(displaySelectedParameterIds);
    return set(selectedParameterIdsAtom, selection.concat(parameterIds.filter((id) => !selection.includes(id))));
});

export const clearManyParameterIdsAtom = atom<null, [parameterId: string[]], void>(null, (get, set, parameterIds) => {
    const selection = get(displaySelectedParameterIds);
    return set(
        selectedParameterIdsAtom,
        selection.filter((id) => !parameterIds.includes(id)),
    );
});

/**
 * Scope
 */

export const withAtomsScope = <C extends React.ComponentType<any>>(Component: C) => {
    type Props = React.ComponentProps<C>;

    const Wrapped = (props: Props) => (
        <ScopeProvider atoms={[selectedParameterIdsAtom]}>
            <Component {...props} />
        </ScopeProvider>
    );

    Wrapped.displayName = `withAtomsScope(${Component.displayName ?? Component.name ?? 'Component'})`;
    return Wrapped;
};
